// extracted by mini-css-extract-plugin
export var bold = "_rs-0";